export default [
  {
    path: "/blog",
    name: "Blog",
    component: () =>
      import(/* webpackChunkName: "blog" */ "@/views/Blog/pages"),
  },
  {
    path: "/list-blog-categories",
    name: "ListBlogCategories",
    component: () =>
      import(
        /* webpackChunkName: "blog" */ "@/views/Blog/pages/ListCategories"
      ),
  },
  {
    path: "/register-posts",
    name: "RegisterPosts",
    component: () =>
      import(/* webpackChunkName: "blog" */ "@/views/Blog/pages/RegisterPosts"),
  },
  {
    path: "/list-posts",
    name: "ListPosts",
    component: () =>
      import(/* webpackChunkName: "blog" */ "@/views/Blog/pages/ListPosts"),
  },
  {
    path: "/list-posts/category/:idCategory",
    name: "ListPostsByCategory",
    component: () =>
      import(
        /* webpackChunkName: "company" */ "@/views/Blog/pages/ListPostsByCategory"
      ),
  },
];
